




















import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation} from 'vuex-class'
import TaskSignaturePreview from './TaskSignaturePreview.vue'
import {Signature} from '@/store/types'

@Component({
  components: {
    TaskSignaturePreview,
  },
})
export default class TaskSignature extends Vue {
  @Getter('signature') public signature!: Signature
  @Mutation('setSignatureModal') public setSignatureModal!: any
}
